import React, { useEffect, useState } from "react";
import MainLayout from "layouts/Main";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Typography, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { ProtectedPaths } from "routes";
import { useAppDispatch, useAppSelector } from "hooks";
import { selectClient, selectCurrentRoleClientId } from "store/selectors";
import { fetchClient } from "store/appSlice";

const SupplyPlanResults = () => {
  const navigate = useNavigate();
  const { date } = useParams();
  const [dateFilter, setDateFilter] = useState(date ? dayjs(date) : null);
  const [snackbar, setSnackbar] = useState(null);
  const dispatch = useAppDispatch();
  const currentRoleClientId = useAppSelector(selectCurrentRoleClientId);
  const client = useAppSelector(selectClient);

  useEffect(() => {
    if (currentRoleClientId) {
      dispatch(fetchClient(currentRoleClientId));
    }
  }, [currentRoleClientId]);

  useEffect(() => {
    if (client && client.contractType !== "FIXED") {
      navigate(`/`);
    }
  }, [client]);

  const handleDateChange = (newValue: any) => {
    const formattedDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : "";
    setDateFilter(dayjs(formattedDate));
    navigate(
      `/${ProtectedPaths.SupplyPlans}/${dayjs(newValue).format("YYYY-MM-DD")}/results`,
      { replace: true },
    );
  };

  const snackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbar(null);
  };

  return (
    <MainLayout
      tabs={[
        {
          label: "Orders",
          link: dateFilter
            ? `supply-plans/${dayjs(dateFilter).format("YYYY-MM-DD")}/orders`
            : `supply-plans/orders`,
        },
        {
          label: "Results",
          link: dateFilter
            ? `supply-plans/${dayjs(dateFilter).format("YYYY-MM-DD")}/results`
            : `supply-plans/results`,
          selected: true,
        },
      ]}
      snackbar={{
        open: snackbar,
        handleClose: snackbarClose,
        type: snackbar?.type,
        message: snackbar?.message,
      }}
    >
      <Box sx={{ mt: "1.2rem" }}>
        <DatePicker
          label={"Select date"}
          sx={{ background: "white", mr: "1rem" }}
          slotProps={{
            textField: { size: "small" },
            clearButton: { size: "small" },
          }}
          value={dateFilter || null}
          onChange={(newValue) => {
            handleDateChange(newValue);
          }}
        />
      </Box>
      {dateFilter && (
        <Stack direction="row" spacing={2} sx={{ mt: 4, mb: 2 }}>
          <Typography variant="h5">Results</Typography>
        </Stack>
      )}
      {dateFilter && (
        <Box sx={{ mt: 4 }}>
          <Typography component="p">No results for selected date.</Typography>
        </Box>
      )}
    </MainLayout>
  );
};

export default SupplyPlanResults;
